var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLoadingSkytrak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 298,
    height: 59,
    viewBox: "0 0 298 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.6 53H9.6L6 59H0L3.6 53ZM13.2 53H19.2L15.6 59H9.6L13.2 53ZM28.8 53H22.8L19.2 59H25.2L28.8 53ZM32.4 53H38.4L34.8 59H28.8L32.4 53ZM48 53H42L38.4 59H44.4L48 53ZM51.6 53H57.6L54 59H48L51.6 53ZM67.2 53H61.2L57.6 59H63.6L67.2 53ZM70.8 53H76.8L73.2 59H67.2L70.8 53ZM86.4 53H80.4L76.8 59H82.8L86.4 53ZM90 53H96L92.4 59H86.4L90 53ZM105.6 53H99.6L96 59H102L105.6 53ZM109.2 53H115.2L111.6 59H105.6L109.2 53ZM124.8 53H118.8L115.2 59H121.2L124.8 53ZM128.4 53H134.4L130.8 59H124.8L128.4 53ZM144 53H138L134.4 59H140.4L144 53ZM147.6 53H153.6L150 59H144L147.6 53ZM163.2 53H157.2L153.6 59H159.6L163.2 53ZM166.8 53H172.8L169.2 59H163.2L166.8 53ZM182.4 53H176.4L172.8 59H178.8L182.4 53ZM186 53H192L188.4 59H182.4L186 53ZM201.6 53H195.6L192 59H198L201.6 53ZM205.2 53H211.2L207.6 59H201.6L205.2 53ZM220.8 53H214.8L211.2 59H217.2L220.8 53ZM224.4 53H230.4L226.8 59H220.8L224.4 53ZM240 53H234L230.4 59H236.4L240 53ZM243.6 53H249.6L246 59H240L243.6 53ZM259.2 53H253.2L249.6 59H255.6L259.2 53ZM262.8 53H268.8L265.2 59H259.2L262.8 53ZM278.4 53H272.4L268.8 59H274.8L278.4 53ZM282 53H288L284.4 59H278.4L282 53ZM297.6 53H291.6L288 59H294L297.6 53Z",
    fill: "url(#paint0_linear_1676_9811)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4079 27.2485H41.9423C44.7915 27.2485 44.9233 24.9014 44.9233 23.8157C44.9233 22.5982 44.6095 21.1046 41.8482 20.2448L29.3783 16.3162C25.2175 15.0046 24 12.3374 24 8.00086C24 3.66432 26.2153 0.363281 31.2297 0.363281H49.4419V5.10774H32.8111C31.3175 5.10774 30.144 5.96752 30.144 8.27071C30.144 9.71413 30.3699 10.9818 32.899 11.8416L44.4652 15.5004C49.0277 16.9438 51.061 18.9332 51.061 23.8596C51.061 28.7861 49.1155 31.993 44.2832 31.993H24.4079V27.2485Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6523 0.363281H65.6143V31.993H59.6523V0.363281ZM82.245 31.993L69.0032 19.9248C67.6037 18.7073 67.3778 17.3015 67.3778 15.72C67.3778 14.5025 68.0556 13.0528 68.9153 12.1931L80.8894 0.363281H88.3011L74.6074 13.3352C73.8857 14.0569 73.1138 14.6029 73.1138 15.6824C73.1138 16.994 74.0614 17.8036 74.9651 18.5755L89.9202 31.9993H82.2387L82.245 31.993Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.384 0.363281H125.804L112.431 22.3284V31.9993H106.469V22.3284L93.0889 0.363281H99.5027L109.443 16.9501L119.384 0.363281Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.559 31.993V5.10774H131.221V0.363281H161.903V5.10774H149.521V31.993H143.559Z",
    fill: "#7BC24E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M169.133 31.993V5.10774C169.133 1.49291 171.029 0.363281 173.74 0.363281H189.693C195.611 0.363281 197.6 4.02204 197.6 10.348C197.6 16.6739 195.523 20.9226 190.276 20.9226H187.113V21.1485L198.228 31.993H190.546L180.335 21.7384C179.658 21.0167 178.842 19.975 178.842 19.0713V18.3496C178.842 17.0819 179.745 16.1781 181.509 16.1781H187.653C190.904 16.1781 191.45 13.9628 191.45 10.348C191.45 6.73316 190.772 5.10774 186.975 5.10774H177.348C175.541 5.10774 175.089 5.55959 175.089 7.36701V31.993H169.127H169.133Z",
    fill: "#7BC24E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M215.317 3.5709C216.447 0.903707 217.664 0 220.513 0C223.362 0 224.58 0.903707 225.71 3.5709L237.64 31.9937H231.358L228.107 23.9922H212.876L209.669 31.9937H203.387L215.317 3.5709ZM214.413 19.7498H226.569L221.417 6.87194C221.235 6.37615 220.921 5.56031 220.513 5.56031C220.105 5.56031 219.792 6.37615 219.61 6.87194L214.413 19.7498Z",
    fill: "#7BC24E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M244.141 0.363281H250.103V31.993H244.141V0.363281ZM266.733 31.993L253.491 19.9248C252.092 18.7073 251.866 17.3015 251.866 15.72C251.866 14.5025 252.544 13.0528 253.404 12.1931L265.378 0.363281H272.789L259.096 13.3352C258.374 14.0569 257.602 14.6029 257.602 15.6824C257.602 16.994 258.55 17.8036 259.453 18.5755L274.409 31.9993H266.727L266.733 31.993Z",
    fill: "#7BC24E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1676_9811",
    x1: 297.6,
    y1: 58.1667,
    x2: 256.966,
    y2: -46.6334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#D6F12C"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#D6F12C;#A6ED5F;#39E3D2;#39E3D2;#39E3D2;#39E3D2;#D6F12C",
    dur: "14s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#A6ED5F"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#A6ED5F;#39E3D2;#39E3D2;#D6F12C;#39E3D2;#39E3D2;#D6F12C;#A6ED5F",
    dur: "14s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#39E3D2"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stop-color",
    values: "#A6ED5F;#39E3D2;#39E3D2;#D6F12C;#39E3D2;#39E3D2;#D6F12C;#A6ED5F",
    dur: "14s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: ".95;.80;.60;.40;.20;0;.20;.40;.60;.80;.95",
    dur: "14s",
    repeatCount: "indefinite"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoadingSkytrak);
export default __webpack_public_path__ + "static/media/icon-loading-skytrak.c9e3dfdd08916955d30454cf5a7b4e69.svg";
export { ForwardRef as ReactComponent };